import Breadcrumb from 'antd/lib/breadcrumb'

import 'antd/lib/breadcrumb/style'

export * from 'antd/lib/breadcrumb'

export default Breadcrumb
